import {PopupAnchor, SourceAnchor} from '@mintdata/mint-kit/impl/components/popover/PopupTypes';
import {Tooltip} from '@mintdata/mint-kit/impl/components/tooltip/Tooltip';
import {InputLabel} from '@mintdata/mint-kit/impl/properties/components/inputLabel/InputLabel';
import * as classnames from 'classnames/bind';
import * as React from 'react';

const styles = require('@mintdata/mint-kit/impl/properties/components/multilineInput/MultilineInput.less');
const cx = classnames.bind(styles);

export interface IMultilineInputProps
{
    className?:string;
    isDisabled?:boolean;
    isLarge?:boolean;
    isInvalid?:boolean;
    validationError?:string;
    isReadOnly?:boolean;
    label?:string | JSX.Element;
    isOutlined?:boolean;
    value:string;
    placeholder?:string;
    htmlType?:string;
    autoComplete?:string;
    onChange?:(event:React.FormEvent<HTMLTextAreaElement>) => void
    onKeyDown?:(event:any) => void
    onFocus?:(event:any) => void
    onBlur?:(event:any) => void
    onRef?:(inputRef:HTMLTextAreaElement) => void
}

export class MultilineInput extends React.Component<IMultilineInputProps>
{
    public static defaultProps:Partial<IMultilineInputProps> = {
        isReadOnly: false,
        isLarge: false,
        isInvalid: false,
        isOutlined: false,
        validationError: '',
        autoComplete: 'on',
        onRef: () =>
        {
        },
    };

    public render():JSX.Element
    {
        const {
            className,
            label,
            value,
            placeholder,
            validationError,
            autoComplete,
            isReadOnly,
            isLarge,
            isOutlined,
            isInvalid,
            isDisabled,
            onFocus,
            onBlur,
            onKeyDown,
            onChange,
            onRef,
        } = this.props;

        return (
            <div className={styles.wrapper}>
                <Tooltip
                    content={validationError}
                    tooltipClassName={styles.tooltip}
                    popoverProps={{
                        sourceAnchor: SourceAnchor.LeftTop,
                        popupAnchor: PopupAnchor.LeftBottom,
                        className: styles.popover,
                    }}
                >
                    <textarea
                        autoComplete={autoComplete}
                        disabled={isDisabled}
                        placeholder={placeholder}
                        className={cx(styles.base, {isOutlined, isLarge, isInvalid}, className)}
                        readOnly={isReadOnly}
                        onChange={onChange}
                        onFocus={onFocus}
                        onKeyDown={onKeyDown}
                        onBlur={onBlur}
                        value={value}
                        ref={onRef}
                    />
                </Tooltip>
                {typeof label === 'string' ? <InputLabel text={label} /> : label}
            </div>
        );
    }
}

